const addProductPrefix = (sku) =>
  typeof sku === 'string' && !sku.startsWith('product:')
    ? `product:${sku}`
    : sku

class ReportPgAdapter {
  constructor (pgConnection) {
    this.pgConnection = pgConnection
  }

  // Returns stock count reports for a location+program, latest first.
  // Each report includes per-generic-sku soh and consumed values.
  async list ({ locationId, programId, limit = 10 }) {
    if (!locationId) throw new Error('locationId is required')
    if (!programId) throw new Error('programId is required')

    const { rows } = await this.pgConnection.query(`
      WITH latest_counts AS (
        SELECT id, stock_count_id, fs_id, program_id, yearweek, submitted_at
        FROM avocado.data_stockcount
        WHERE fs_id = $1 AND program_id = $2
        ORDER BY submitted_at DESC
        LIMIT $3
      )
      SELECT
        lc.id,
        lc.stock_count_id,
        lc.fs_id AS location_id,
        lc.program_id,
        lc.yearweek,
        lc.submitted_at,
        scl.sku,
        scl.closing,
        scl.sold,
        scl.extra_fields
      FROM latest_counts lc
      LEFT JOIN avocado.data_stockcountline scl ON scl.stock_count_id = lc.id
      ORDER BY lc.submitted_at DESC, scl.sku
    `, [locationId, programId, limit])

    const reportsMap = new Map()
    for (const row of rows) {
      if (!reportsMap.has(row.id)) {
        reportsMap.set(row.id, {
          id: row.stock_count_id,
          locationId: row.location_id,
          programId: row.program_id,
          yearweek: row.yearweek,
          submittedAt: row.submitted_at,
          products: {}
        })
      }
      if (!row.sku) continue

      // Use extra fields when exist or default to closing and sold columns
      const report = reportsMap.get(row.id)
      const extraFields = row.extra_fields || {}
      const soh = extraFields['field:standard-physical-count'] != null
        ? extraFields['field:standard-physical-count']
        : row.closing
      const consumed = extraFields['field:standard-consumed'] != null
        ? extraFields['field:standard-consumed']
        : row.sold

      report.products[addProductPrefix(row.sku)] = { soh, consumed }
    }

    return Array.from(reportsMap.values())
  }
}

module.exports = ReportPgAdapter
